export const descriptionValidation = (schema, minCountWords) => {
    return schema.test(
        'isMinCountWord',
        `Your description needs to be at least ${minCountWords} words.`,
        (value) => (value?.length > 0 && value?.split(" ").length - 1) >= minCountWords - 1
    )
}